import { Box } from '@mui/material';
import HeaderNotifications from './Notifications';
import LanguageSwitcher from './LanguageSwitcher';
import React from 'react';
import { NotificationsProvider  } from '../../../contexts/notificationsContext';
import MessageReceiver from '../../../notify/signalr';
import DashboardSwitcher from './DashboardSwitcher';

function HeaderButtons() {
  return (
    <NotificationsProvider >
      
      <Box style={{display:"flex",alignItems:"center",gap:1}}>

      
      <DashboardSwitcher/>
    <Box
    >
      <MessageReceiver />
      <HeaderNotifications />
      <LanguageSwitcher />
    </Box>
    </Box>
  </NotificationsProvider >
    
  );
}

export default HeaderButtons;
